import { render, staticRenderFns } from "./InvoiceAndPaymentTotalCards.vue?vue&type=template&id=54c29813&scoped=true&"
import script from "./InvoiceAndPaymentTotalCards.vue?vue&type=script&lang=js&"
export * from "./InvoiceAndPaymentTotalCards.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAndPaymentTotalCards.vue?vue&type=style&index=0&id=54c29813&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c29813",
  null
  
)

export default component.exports